import { render } from "./WizardPage.vue?vue&type=template&id=22e46ed2&ts=true"
import script from "./WizardPage.vue?vue&type=script&lang=ts"
export * from "./WizardPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__